
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keyword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currentPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"keyword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keyword"}}},{"kind":"Argument","name":{"kind":"Name","value":"requestType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestType"}}},{"kind":"Argument","name":{"kind":"Name","value":"userStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"results"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneDialCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isBan"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profile"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"picture"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locationName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isInProgressDelivery"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryAcceptance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accepted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"noResponse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"acceptanceRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priorityFactor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"earlyCompletions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"earlyCompletionThresholdMeters"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"windowDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overridePercent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overrideExpiresAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overrideReason"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":833}};
    doc.loc.source = {"body":"query getAllUsers($currentPage: Int, $keyword: String, $requestType: String, $userStatus: String, $locationId: Int) {\n\tgetAllUsers(\n\t\tcurrentPage: $currentPage\n\t\tkeyword: $keyword\n\t\trequestType: $requestType\n\t\tuserStatus: $userStatus\n\t\tlocationId: $locationId\n\t) {\n\t\tstatus\n\t\terrorMessage\n\t\tcount\n\t\tresults {\n\t\t\tid\n\t\t\temail\n\t\t\tphoneDialCode\n\t\t\tphoneNumber\n\t\t\tisBan\n\t\t\tisActive\n\t\t\tactiveStatus\n\t\t\tuserStatus\n\t\t\tcreatedAt\n\t\t\tprofile {\n\t\t\t\tprofileId\n\t\t\t\tfirstName\n\t\t\t\tlastName\n\t\t\t\tcountry\n\t\t\t\tpicture\n\t\t\t}\n\t\t\tlocation {\n\t\t\t\tid\n\t\t\t\tlocationName\n\t\t\t}\n\t\t\tisInProgressDelivery\n\t\t\tdeliveryAcceptance {\n\t\t\t\toffers\n\t\t\t\taccepted\n\t\t\t\tnoResponse\n\t\t\t\tacceptanceRate\n\t\t\t\tpriorityFactor\n\t\t\t\tcompletions\n\t\t\t\tearlyCompletions\n\t\t\t\tearlyCompletionThresholdMeters\n\t\t\t\twindowDays\n\t\t\t\toverridePercent\n\t\t\t\toverrideExpiresAt\n\t\t\t\toverrideReason\n\t\t\t}\n\t\t}\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getAllUsers"] = oneQuery(doc, "getAllUsers");
        
